import createConverter from './lib/create_converter';
import Err from 'models/err';

export default createConverter(Err);
